<!-- TODO: Convert hasNetworkConnection to a signal for proper reactivity -->
@if (!hasNetworkConnection) {
  <section class="no-network-connection-message-container">
    <ion-icon [attr.aria-hidden]="true" name="wifi-outline"></ion-icon>
    <span>Geen netwerkverbinding</span>
  </section>
}
